import { isDefined } from '@hover/utilities';

import type { RegionWithDisabledRegions } from 'src/modules/homeownerApp/hooks/useVariationEdits';
import type { DesignerProduct } from 'src/modules/homeownerApp/productCatalogData';
import {
  getFacetValue,
  isGenericProduct,
  isPaintProduct,
} from 'src/modules/homeownerApp/productCatalogData';

const formatRoofing = (product: DesignerProduct) => {
  const color = product.color?.name || '';

  return {
    primaryLabel: color,
    secondaryLabel: product.provider.name,
    altText: [color, product.provider.name].join(', '),
  };
};

const formatWalls = (product: DesignerProduct) => {
  const color = product.color?.name || '';
  const size = getFacetValue(product, 'SIZING');

  return {
    primaryLabel: [color, size].filter(isDefined).join(', '),
    secondaryLabel: product.provider.name,
    altText: [color, size, product.provider.name].filter(isDefined).join(', '),
  };
};

const formatWindows = (product: DesignerProduct) => {
  const grillePattern = getFacetValue(product, 'grille_pattern') || '';

  return {
    primaryLabel: grillePattern,
    secondaryLabel: product.provider.name,
    altText: [grillePattern, product.provider.name].join(', '),
  };
};

const formatPaint = (product: DesignerProduct) => {
  const color = product.color?.name || '';

  return {
    primaryLabel: color,
    secondaryLabel: product.provider.name,
    altText: [color, product.provider.name].join(', '),
  };
};

const formatTrim = (product: DesignerProduct) => {
  const color = product.color?.name || '';

  return {
    primaryLabel: color,
    secondaryLabel: product.provider.name,
    altText: [color, product.provider.name].join(', '),
  };
};

const formatGeneric = (product: DesignerProduct) => {
  const { name } = product.variation;

  return {
    primaryLabel: name,
    secondaryLabel: '',
    altText: name,
  };
};

export const formatProductDescriptions = (
  region: RegionWithDisabledRegions | undefined,
  product: DesignerProduct,
) => {
  const isGeneric = isGenericProduct(product);
  const isPaint = isPaintProduct(product);

  if (isPaint) {
    return formatPaint(product);
  }

  if (region === 'roof' && !isGeneric) {
    return formatRoofing(product);
  }

  if (region === 'walls' && !isGeneric) {
    return formatWalls(product);
  }

  if (region === 'windows' && !isGeneric) {
    return formatWindows(product);
  }

  if (region === 'trim' && !isGeneric) {
    return formatTrim(product);
  }

  return formatGeneric(product);
};

export const formatPellaWindows = (product: DesignerProduct) => {
  const grillePattern = getFacetValue(product, 'grille_pattern') || '';
  const windowType = getFacetValue(product, 'window_type') || '';

  return {
    primaryLabel: grillePattern,
    secondaryLabel: windowType,
    altText: [grillePattern, windowType, product.provider.name].join(', '),
  };
};
